import angular from 'angular';
import i18n from '../i18n';
import switchButtonDirective from './switch-button-directive';

/**
 * @ngdoc module
 * @name akamai.components.switch-button
 *
 * @guideline https://design.akamai.com/components/switch/
 *
 * @description
 * Switch button is similar to a radio button. It lets users choose between two values.
 * Traditionally, these values are binary operations: On | Off or Allow | Deny.
 * The switch affordance lets users think of a real-world switch that can toggle between two states.
 * If a label isn't needed, consider {@link ../switch/ akam-switch}.
 *
 * @example switch-button.html
 * <akam-switch-button
 *   ng-model="..."
 *   size="medium">
 * </akam-switch-button>
 */
export default angular.module('akamai.components.switch-button', [
  i18n.name
])

/**
 * @ngdoc directive
 *
 * @name akamSwitchButton
 *
 * @description Creates a switch button control
 *
 * @restrict E
 *
 * @param {boolean} ng-model The switch-button's state
 *
 * @param {string|TranslateKey} [on-label=On] The label text for when the
 * switch-button is turned on
 *
 * @param {Object} [on-label-values] If `TranslateKey` is used for `on-label`, this object
 * hash will be used for translations with variable interpolation. See
 * [angular-translate's translate-value support](https://angular-translate.github.io/docs/#/guide/06_variable-replacement).
 *
 * @param {string|TranslateKey} [off-label=Off] The label text for when the
 * switch-button is turned off
 *
 * @param {Object} [off-label-values] If `TranslateKey` is used for `off-label`, this object
 * hash will be used for translations with variable interpolation. See
 * [angular-translate's translate-value support](https://angular-translate.github.io/docs/#/guide/06_variable-replacement).
 *
 * @param {boolean} [is-disabled=false] If disabled, no user interaction will be possible.
 *
 * @param {boolean} [is-readonly=false] If readonly, no user interaction will be possible but the
 * text will be easier to read.
 *
 * @param {string} [theme=color] The theme of the switch-button. Can
 * be either 'color' or 'grayscale'.
 *
 * @param {string} [size=small] The size of the switch-button. Can be
 * either 'small' or 'medium'
 */
  .directive('akamSwitchButton', switchButtonDirective);
